import React, { useEffect, useState } from "react";
import PreviewPatientSampleInformation from "./PreviewPatientSampleInformation";
import PreviewChart from "./PreviewChart";
import PreviewConstantSection from "./PreviewConstantSection";
import PreviewPatientTable from "./PreviewPatientTable";
import PreviewTestResultHistory from "./PreveiwTestHistory";


import DiviTum from "../../assets/div-tum.png";
import "./styles/ReportPdfView.css";


const A4WidthInMillimeters = 210;
const A4HeightInMillimeters = 297;
const DefaultPPI = 96; // Fallback PPI value

const ReportPdfView = ({
  laboratoryDirector,

  //Patient Table
  patientName,
  patientDOB,
  patientSex,
  patientID,
  orderBy,
  reportRecipient,
  contactInfo,
  amendedNotes,

  //Patient Sample Information
  orderDate,
  collectedDate,
  collectedTime,
  patientSampleType,
  reportedDate,
  sampleID,
  institutionSampleID,

  //datepoints
  datePointsTable,
  masterCssClassName,
  previewReportRecipientInfoFieldCssClass,
  previewContactInfoFieldCssClas,
  topCssClass,
  previewChartContainerCssClass,
  pdfViewFinalReportSectionCssClass,
  forLocalPdf = false,
}: any) => {

  const [ppi, setPpi] = useState<number>(0.0);
  const [a4WidthInPixels, setA4WidthInPixels] = useState<number>(0.0);
  const [a4HeightInPixels, setA4HeightInPixels] = useState<number>(0.0);

  useEffect(() => {
    const screenWidthInPixels = window.screen.width;
    const screenWidthInInches = screenWidthInPixels / DefaultPPI;
    const calculatedPpi = screenWidthInPixels / screenWidthInInches;



    setPpi(calculatedPpi);
    console.log("calculated PPI: ", calculatedPpi);
    const a4WidthInPixelsLocal = (A4WidthInMillimeters / 25.4) * calculatedPpi;
    const a4HeightInPixelsLocal = (A4HeightInMillimeters / 25.4) * calculatedPpi;
    console.log("a4WidthInPixelsLocal: ", a4WidthInPixelsLocal);
    console.log("a4HeightInPixelsLocal: ", a4HeightInPixelsLocal);
    setA4WidthInPixels(a4WidthInPixelsLocal);
    setA4HeightInPixels(a4HeightInPixelsLocal);

    setDataToLocalStorage();
  }, []);

  const setDataToLocalStorage = () => {
    const jsonData = {
      laboratoryDirector,

      //Patient Table
      patientName,
      patientDOB,
      patientSex,
      patientID,
      orderBy,
      reportRecipient,
      contactInfo,
      amendedNotes,

      //Patient Sample Information
      orderDate,
      collectedDate,
      collectedTime,
      patientSampleType,
      reportedDate,
      sampleID,
      institutionSampleID,

      //datepoints
      datePointsTable,
    };
    console.log("will set jsonData: ", jsonData);
    localStorage.setItem("report", JSON.stringify(jsonData));
  };

  return (
    <div id="report_pdf_view_container" className={masterCssClassName}>
      <div className="header-section">
        <div className="header-log">
          <div className="divitum-tka">
            <div className="logo">
              <img src={DiviTum} alt="DidiTumTka Logo"></img>
            </div>
          </div>
        </div>
        <div className="headline">
          <h2>TEST RESULTS</h2>
          {/* <div className="divider-c"></div> */}
          <h5>FINAL REPORT</h5>
        </div>
        <div className="top-info">
          <div className="lab-order-info">
            <div className="lab-director">
              <div className="director-name">Laboratory director:</div>
              <div className="director-value">{laboratoryDirector}</div>
            </div>

            {/* <div className="order-by">
              <div className="order-by-name">Ordered by: </div>
              <div className="order-by-value">{orderBy}</div>
            </div> */}
          </div>
          <div className="page-no">
            <div className="page">Page</div>
            <div className="number">1 of 1</div>
          </div>
        </div>

      </div>
      <div className="pdfview-patient-table">
        <PreviewPatientTable
          patientName={patientName}
          patientDOB={patientDOB}
          patientSex={patientSex}
          patientID={patientID}
          orderBy={orderBy}
          reportRecipient={reportRecipient}
          contactInfo={contactInfo}
          amendedNotes={amendedNotes}
          previewReportRecipientInfoFieldCssClass={previewReportRecipientInfoFieldCssClass}
          previewContactInfoFieldCssClas={previewContactInfoFieldCssClas}
        />
      </div>
      <div className="pdfview-psi-history-test-result">
        <PreviewPatientSampleInformation
          orderDate={orderDate}
          collectedDate={collectedDate}
          collectedTime={collectedTime}
          patientSampleType={patientSampleType}
          reportedDate={reportedDate}
          sampleID={sampleID}
          institutionSampleID={institutionSampleID}
        />
        <PreviewTestResultHistory datePointsTable={datePointsTable} />
      </div>
      
      <PreviewChart
        datePointsTable={datePointsTable}
        masterCssClassName={masterCssClassName}
        previewChartContainerCssClass={previewChartContainerCssClass}
      />

      <PreviewConstantSection forLocalPdf={forLocalPdf} />
    </div>
  );
};

export default ReportPdfView;
